import { AnimatePresence } from "framer-motion";
import { usePageContext } from "vike-react/usePageContext";
import FrozenPageContext from "./FrozenPageContext";
import PageTransition from "./PageTransition";

export default function TransitionProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const pageContext = usePageContext();
  const pathname = pageContext.urlPathname;

  // initial={false}: the page present on first load renders at its resting
  // state, so the server HTML is visible before hydration. PageTransition
  // plays that first entrance in CSS instead; later navigations animate here.
  return (
    <AnimatePresence mode="wait" initial={false}>
      <PageTransition key={pathname} pathname={pathname}>
        {/* Freeze this route's data so the outgoing page (kept mounted by
            AnimatePresence during its exit animation) doesn't re-render with the
            incoming route's data shape and crash. */}
        <FrozenPageContext pageContext={pageContext}>
          {children}
        </FrozenPageContext>
      </PageTransition>
    </AnimatePresence>
  );
}
